import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-azay-logo',
  templateUrl: './footer-azay-logo.component.html',
  styleUrls: ['./footer-azay-logo.component.scss']
})
export class FooterAzayLogoComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
